import React from 'react';
import PageList from '../../../components/admin/pages/PageList';

const Pages: React.FC = () => {

    return (<div>
        <PageList />
    </div>)
};

export default Pages;